import { useEffect, useState } from 'react';
import { usePsychologistContext } from '../contexts/PsychologistContext';
import { useAuth } from '../contexts/AuthContext';

const RANKING_WEBHOOK_URL = 'https://hook.us1.make.com/wbr01ud7bvw6nubj50477jiscm56810w';

export interface RankingTransition {
  rankingActual: string | null;
  rankingAnterior: string | null;
  loading: boolean;
  error: boolean;
}

/**
 * Trae ranking_actual/ranking_anterior del mismo webhook de Make que ya usa ProfileMetricsTab
 * para decidir el journey NZ. Se extrajo acá para que otras pantallas (ej. "Sobre tu atención")
 * puedan usar la misma fuente de verdad sin duplicar la lógica de fetch.
 */
export function useRankingTransition(): RankingTransition {
  const { psychologist } = usePsychologistContext();
  const { psychologistId } = useAuth();
  const resolvedId = psychologistId || psychologist?.id || '';

  const [rankingActual, setRankingActual] = useState<string | null>(null);
  const [rankingAnterior, setRankingAnterior] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!resolvedId) { setLoading(false); return () => { cancelled = true; }; }
    setLoading(true);
    setError(false);
    fetch(`${RANKING_WEBHOOK_URL}?psychologist_id=${resolvedId}`)
      .then((r) => r.json())
      .then((data: { ranking_actual: string; ranking_anterior: string }) => {
        if (cancelled) return;
        setRankingActual(data.ranking_actual);
        setRankingAnterior(data.ranking_anterior);
      })
      .catch((err) => {
        if (cancelled) return;
        console.error('No se pudo obtener ranking_actual/ranking_anterior de la psicóloga:', err);
        setError(true);
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [resolvedId]);

  return { rankingActual, rankingAnterior, loading, error };
}
